import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ForgotPassword } from "@/components/installFlowV2/forgot-password";

export const Route = createFileRoute('/installFlow/forgot-password')({
  component: ForgotPassword,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
})

